import React from "react";

import * as styleConstants from "@churchofjesuschrist/eden-style-constants";
import styled from "styled-components";

const BarColor = styled.div`
  ${props => {
  if (props.color !== "") {
    const backgroundColor = styleConstants[props.color];
    return `
      background: ${backgroundColor} linear-gradient(90deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0) 100%);
      height: ${styleConstants.spacing16};
     `;
  } else {
    return `display: none`;
  }
}}
`;

const GradiantTopBar = ({
  color,
}) => {
  return (
    <BarColor color={color} />
  );
}

export default GradiantTopBar;